/*  eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import { GridView, ListView, Menu } from '@one-thd/sui-icons';
import proptypes from 'prop-types';

import { publish } from '../publisher';
import { useSearchModelData } from '../hooks/useSearchModelData';
import { ToggleTile } from './ToggleTile/ToggleTile';

const { func, string, bool } = proptypes;

const ResultsToggleLayout = ({
  activeLayout, toggleActiveLayout, showToggle, isTableView, hideListIcon, useTileView
}) => {
  const { data } = useSearchModelData();
  const { searchReport } = data?.searchModel || {};
  const { totalProducts = 0 } = searchReport || {};
  const GRID = 'Grid';
  const LIST = 'List';
  const TABLE = 'Table';
  const ACTIVE_COLOR = 'brand';
  const INACTIVE_COLOR = 'inactive';
  let gridColor;
  let listColor;
  let tableColor;

  const toggleLayout = (newLayout) => {
    if (newLayout === activeLayout) {
      return;
    }
    toggleActiveLayout(newLayout);
    publish('select-list-layout', newLayout);
  };

  if (activeLayout === GRID) {
    gridColor = ACTIVE_COLOR;
    listColor = INACTIVE_COLOR;
    tableColor = INACTIVE_COLOR;
  } else if (activeLayout === LIST) {
    gridColor = INACTIVE_COLOR;
    listColor = ACTIVE_COLOR;
    tableColor = INACTIVE_COLOR;
  } else if (activeLayout === TABLE) {
    gridColor = INACTIVE_COLOR;
    listColor = INACTIVE_COLOR;
    tableColor = ACTIVE_COLOR;
  }

  const tileData = {
    grid: {
      value: 'Grid',
      text: 'Grid View',
      icon: <GridView size="small" />,
      selected: activeLayout === GRID
    },
    list: {
      value: 'List',
      text: 'List View',
      icon: <ListView size="small" />,
      selected: activeLayout === LIST
    },
    table: {
      value: 'Table',
      text: 'Table View',
      icon: <Menu size="small" />,
      selected: activeLayout === TABLE
    }
  };

  return (
    <>
      {(showToggle || totalProducts > 0) && (
        <div className="sui-flex sui-flex-row sui-justify-end" data-component="ResultsToggleLayout">
          {isTableView && (
            <button
              className="sui-p-1"
              type="button"
              onClick={() => toggleLayout(TABLE)}
            >
              {useTileView ? <ToggleTile item={tileData.table} />
                : <Menu color={tableColor} size="small" />}
            </button>
          )}
          <button
            className="sui-p-1"
            type="button"
            onClick={() => toggleLayout(GRID)}
          >
            {useTileView ? <ToggleTile item={tileData.grid} />
              : <GridView color={gridColor} />}
          </button>
          {!hideListIcon && (
            <button
              className="sui-p-1"
              type="button"
              onClick={() => toggleLayout(LIST)}
            >
              {useTileView ? <ToggleTile item={tileData.list} />
                : <ListView color={listColor} />}
            </button>
          )}
        </div>
      )}
    </>
  );
};

ResultsToggleLayout.propTypes = {
  toggleActiveLayout: func.isRequired,
  activeLayout: string.isRequired,
  showToggle: bool,
  isTableView: bool,
  hideListIcon: bool,
  useTileView: bool
};

ResultsToggleLayout.defaultProps = {
  showToggle: false,
  isTableView: false,
  hideListIcon: false,
  useTileView: false
};

ResultsToggleLayout.displayName = 'ProductResultsToggleLayout';

export { ResultsToggleLayout };
